<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogHeader>
        <panel-tools
            [isPanelToolsDialog]="true"
            [showLangButton]="appService.languageCount > 1"
            (setCurrentLangForm)="setCurrentLangForm($event)"
        >
        </panel-tools>
    </ng-container>
    <ng-container dialogContent>
        <div
            #formRef
            class="languages-dialog-form-container load-form-container"
            [formGroup]="form"
            (keydown)="keyDownFunction($event)"
        >
            <div *ngIf="formInit">
                <div
                    fxLayout="row wrap"
                    fxLayoutAlign="flex-start"
                    fxLayoutGap="16px"
                    fxLayoutGap.sm="0px"
                    fxLayoutGap.xs="0px"
                    *ngFor="let lang of appService.languages | keyvalue"
                    [class.!hidden]="lang?.value != currentLangForm"
                >
                    <div fxFlex="0 1 100%">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                autoFocus: true,
                                label:
                                    appService.language_dictionary.system_layer_field_name +
                                    (appService.languageCount > 1 ? ' (' + lang?.value?.lang + ')' : ''),
                                inputType: 'text',
                                name: lang?.value?.lang,
                                required: lang?.value?.lang == appService.defaultLanguage,
                                validations: [
                                    {
                                        name: 'required',
                                        message: appService.language_dictionary.system_layer_field_name_error,
                                    },
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form.get('name')"
                        ></ng-container>
                    </div>
                </div>
                <div
                    fxLayout="row wrap"
                    fxLayoutAlign="flex-start"
                    fxLayoutGap="16px"
                    fxLayoutGap.sm="0px"
                    fxLayoutGap.xs="0px"
                    *ngFor="let lang of appService.languages | keyvalue"
                    [class.!hidden]="lang?.value !== currentLangForm"
                >
                    <div fxFlex="0 1 100%">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.lay_coordinate_system,
                                inputType: 'text',
                                name: lang?.value?.lang,
                                required: lang?.value?.lang === appService.defaultLanguage,
                                options: this.coordinateSystems ? this.coordinateSystems : [],
                                validations: [
                                    {
                                        name: 'required',
                                        message: appService.language_dictionary.system_field_required,
                                    },
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form.get('coordinate_system')"
                        ></ng-container>
                    </div>
                </div>
                <div
                    fxLayout="row wrap"
                    fxLayoutAlign="flex-start"
                    fxLayoutGap="16px"
                    fxLayoutGap.sm="0px"
                    fxLayoutGap.xs="0px"
                    *ngFor="let lang of appService.languages | keyvalue"
                    [class.!hidden]="lang?.value != currentLangForm"
                >
                    <div fxFlex="0 1 100%">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label:
                                    appService.language_dictionary.system_layer_field_description +
                                    (appService.languageCount > 1 ? ' (' + lang?.value?.lang + ')' : ''),
                                inputType: 'text',
                                name: lang?.value?.lang,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form.get('description')"
                        ></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            (clickEvent)="save()"
            [label]="appService.language_dictionary.system_save"
            icon="content-save"
            height="mini"
        >
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_close"
            icon="close"
            color="light"
            height="mini"
        >
        </fui-button>
    </ng-container>
</app-dialog>
